import {NgModule, provideBrowserGlobalErrorListeners, provideZoneChangeDetection} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { App } from './app';
import {AvailabilityUpdateMainComponent} from './components/availability-update-main/availability-update-main.component';
import {
  AvailabilityAppErrorNotFoundComponent
} from './components/availability-app-errors/availability-app-error-not-found/availability-app-error-not-found.component';
import {ReactiveFormsModule} from '@angular/forms';
import {provideHttpClient} from '@angular/common/http';
import {SharedModule} from './shared/shared.module';
import {AppRoutingModule} from './app-routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {AvailabilityNavbarComponent} from './components/availability-navbar/availability-navbar.component';
import {AvailabilityUpdateFormComponent} from './components/availability-update-form/availability-update-form.component';
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';
import {MY7N_ENV_CONFIG, my7nEnvConfigFactory} from '../../../evaluation/src/functions/my7n-env-config';
import {AvailabilityService} from './shared/services/availability.service';

@NgModule({
  declarations: [
    App,
    AvailabilityNavbarComponent,
    AvailabilityUpdateMainComponent,
    AvailabilityAppErrorNotFoundComponent,
    AvailabilityUpdateFormComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule,
    AppRoutingModule,
    MatRadioButton,
    MatRadioGroup
  ],
  providers: [
    provideHttpClient(),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    {
      provide: MY7N_ENV_CONFIG,
      useFactory: my7nEnvConfigFactory
    },
    AvailabilityService
  ],
  bootstrap: [
    App
  ]
})
export class AppModule {}
